<template>
  <div class="loader-preview-wrapper">
      <div v-if="type=='circle'" class="spinner-circle">
          <div class="double-bounce1" :style="style"/>
          <div class="double-bounce2" :style="style"/>
      </div>
      <div v-else-if="type=='square'" class="spinner-square" :style="style"/>
      <div v-else class="skeleton">
        <span>{{texts.general.skeletonHint}}</span>
      </div>
  </div>

</template>

<script>
export default {
  name: "LoaderPreview",
  props: {
    type: {
      type: String,
      default: "circle"
    },
    color: {
      type: String,
      default: "#1C5D7D"
    },
    speed: {
      type: Number,
      default: 250
    }
  },
  computed: {
    style() {
      return {
        backgroundColor: this.color,
        animationDuration:
          (this.type == "circle" ? 2 : 1) + this.speed / 1000 + "s"
      };
    }
  }
};
</script>

<style>

.loader-preview-wrapper{
  margin-top: 1em;
}
.spinner-circle {
  width: 80px;
  height: 80px;
  position: relative;
}

.spinner-circle,
.spinner-square {
  margin-bottom: 15px;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50% !important;
  background-color: #333;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-animation: sk1-bounce 2.1s infinite ease-in-out;
  animation: sk1-bounce 2.1s infinite ease-in-out;
}

@keyframes sk1-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
.double-bounce2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner-square {
  width: 80px;
  height: 80px;
  background-color: #333;
  -webkit-animation: sk-rotateplane 1.2s infinite ease-in-out;
  animation: sk-rotateplane 1.2s infinite ease-in-out;
}

@keyframes sk-rotateplane {
  0% {
    transform: perspective(120px) rotateX(0deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(0deg) rotateY(0deg);
  }
  50% {
    transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
    -webkit-transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
  }
  100% {
    transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
    -webkit-transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
  }
}

.skeleton {
    max-width: 225px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/LoaderPreview.vue